import { render, staticRenderFns } from "./BillOfLading.vue?vue&type=template&id=323a5b6b&"
import script from "./BillOfLading.vue?vue&type=script&lang=js&"
export * from "./BillOfLading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports